@if (isVisible()) {
  <div class="combo-guide-block" [class.has-arrows]="hasMultiple()">
    @if (hasMultiple()) {
      <div class="arrow">
        <mat-icon (click)="previous()">chevron_left</mat-icon>
      </div>
    }
    <span class="text upper" [class.clickable]="clickable" (click)="onTextClick()">{{ currentMessage() }}</span>
    @if (hasMultiple()) {
      <div class="arrow">
        <mat-icon (click)="next()">chevron_right</mat-icon>
      </div>
    }
  </div>
}
